// extracted by mini-css-extract-plugin
export var home = "bgabout-module--home--2VKAX";
export var header = "bgabout-module--header--10lRp";
export var pstyles = "bgabout-module--pstyles--2H4Qz";